<template>
  <CardWrapper :loading="!article" class="card-2">
    <template v-if="article">
      <h2>
        {{ article.article_name }}
        <small class="text-caption">{{ article.publication_year }}</small>
      </h2>

      <div class="article-link">
        DOI URL:
        <a :href="article.doi_url" target="_blank">{{ article.doi }}</a>
        <i class="fa fa-external-link-alt q-ml-xs"></i>
      </div>
    </template>
  </CardWrapper>
</template>

<script>
import CardWrapper from '../CardWrapper'

export default {
  components: {
    CardWrapper
  },

  props: {
    article: Object
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

.card-2 {
  background-color $tertiary
  color white

  h2 {
    font-size 2rem
    font-weight 500
  }

  >>> .article-link {
    font-size 14px
    font-weight 500
    > a {
      color white
    }
  }
}
</style>
